import script from "./QuestionAnswer12.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionAnswer12.vue?vue&type=script&setup=true&lang=js"

import "./QuestionAnswer12.vue?vue&type=style&index=0&id=37f554d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f554d8"]])

export default __exports__